import {
    buildIdentityAccountUrl,
    buildIdentitySignInUrl,
    createTaktWebAuthClient,
    getWebAuthSessionUser,
    isAdminWebAuthSession,
    type TaktIdentityAccountPage,
} from "@takt/web-auth"
import { authBaseUrl, config } from "./config"

export const authClient = createTaktWebAuthClient(authBaseUrl)

export async function loadSession() {
    const response = await authClient.getSession()

    if (response.error) {
        throw new Error("Groomio Admin could not verify your session. Refresh and try again.", {
            cause: response.error,
        })
    }

    return response.data ?? null
}

export function buildSignInUrl(returnTo: string) {
    return buildIdentitySignInUrl({
        identityOrigin: config.identityOrigin,
        continuation: { app: "admin", returnTo },
    })
}

export function buildAccountUrl(page: TaktIdentityAccountPage = "overview") {
    return buildIdentityAccountUrl({
        identityOrigin: config.identityOrigin,
        page,
        continuation: { app: "admin", returnTo: window.location.pathname + window.location.search },
    })
}

export { getWebAuthSessionUser, isAdminWebAuthSession }
